import { i18n, inject, pr, React, ui } from "aaa";
import { MessageScreen } from "../common/MessageScreen";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { LinkAccountStore } from "./LinkAccountStore";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: LinkAccountStore;
}

@i18n.injectIntl
@inject("externalInterfaceStore", "authStore")
export class LinkAccountSuccess extends React.Component<IProps & i18n.InjectedIntlProps, {}> {
    render() {
        const product = this.props.store.cardStore.card ? this.props.store.cardStore.card.productI18N : "BankCard";
        const message = this.props.store.cardAccountsStore.linkedAccounts.length > 0 ?
            ui.__("linkAccount.success.accounts_linked", { product }) :
            ui.__("linkAccount.success.accounts_not_linked");

        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                message={message}
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/linkAccount/LinkAccountSuccess.tsx